<div class="bg-dark offline" *ngIf="parameters.offline">
    <p class="offline-title bg-alert color-light text-align-center font-14">
        Offline</p>
</div>

<div class="tiles-wrapper"
     *ngIf="parameters.selectedModule.moduleStatus
        && parameters.selectedModule.controllerStatus
        && menu.downloaded"
     [ngStyle]="{ 'margin-top.px': parameters.offline ? 35 : 0}">
    <div class="tiles">
        <div class="tiles__block--alarm" *ngIf="tiles.alarm[0]">
            <div class="tiles__container"
                data-testid="container"
                *ngIf="tiles.createContainer">
                <div class="tiles__container-header bg-container">
                    <img class="tiles__container-img bg-style"
                         ngSrc="/assets/img/id_icons/29.svg"
                         width="40" height="40" alt="" />
                    <p class="tiles__container-title color-light">
                       {{ subtitle(1096) }}
                    </p>
                </div>
            </div>
            <div class="tiles__items">
                <div class="tiles__item tile bg-light"
                     *ngFor="let value of tiles.alarm">
                    <tile [tile]="value"></tile>
                </div>
            </div>
        </div>

        <div class="tiles__block--container">
            <ng-container *ngIf="tiles.createContainer">
                <div class="tiles__container"
                    data-testid="container"
                    *ngFor="let val of tiles.container | orderByObject; let idx = index">

                    <div class="tiles__container-header bg-container cursor-pointer"
                        *ngIf="val.values.visibility && val.values.count > 0"
                        (click)="val.values.expanded = !val.values.expanded">
                        <img class="tiles__container-img bg-style"
                             ngSrc="{{ setIcon(val['values']['params']['iconId']) }}"
                             width="40" height="40" alt="" />
                        <p class="tiles__container-title color-light">
                            {{ subtitle(val['values']['params']['txtId']) }}
                        </p>
                        <div class="tiles__container-arrow">
                            <img ngSrc="/assets/img/icons/drop-down-arrow.svg"
                                 class="tiles__container-arrow-img"
                                 [class]="{ 'tiles__container-arrow-img--rotate': val.values.expanded }"
                                 width="20" height="20" alt="" />
                        </div>
                    </div>

                    <div class="tiles__items" *ngIf="val.values.expanded">
                        <div class="tiles__item bg-light"
                            *ngFor="let value of val.elements | tilesOrder">
                             <tile [tile]="value"></tile>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>

        <div class="tiles__block--withoutContainer">
            <div class="tiles__container"
                data-testid="container"
                *ngIf="isOpenContainer()">
                <div class="tiles__container-header bg-container cursor-pointer"
                    (click)="tiles.withoutContainer.expanded = !tiles.withoutContainer.expanded">
                    <img class="tiles__container-img bg-style"
                        ngSrc="/assets/img/id_icons/72.svg"
                        width="40" height="40" alt="" />
                    <p class="tiles__container-title color-light">
                        {{ subtitle(307) }}
                    </p>
                    <div class="tiles__container-arrow">
                        <img class="tiles__container-arrow-img"
                            ngSrc="/assets/img/icons/drop-down-arrow.svg"
                            [ngClass]="{ 'tiles__container-arrow-img--rotate': tiles.withoutContainer.expanded }"
                            width="20" height="20" alt="" />
                    </div>
                </div>
            </div>

            <div class="tiles__items"
                *ngIf="tiles.withoutContainer.expanded">
                <div class="tiles__item bg-light"
                    *ngFor="let value of tiles.withoutContainer.elements | tilesOrder ">
                     <tile [tile]="value"></tile>
                </div>
            </div>
        </div>
    </div>
</div>

<inactive-module></inactive-module>

<div class="module-inactive bg-light-shadow"
     *ngIf="parameters.selectedModule.moduleStatus === null && parameters.selectedModule.controllerStatus === null">
    <p class="module-inactive__info bg-style color-light font-16 cursor-pointer"
       (click)="settingsAccount.getAccountInformation(); tiles.registerModule()">
        {{ subtitle(1319) }}
    </p>
</div>
